const ANALYTICS_OWNER_IDENTITY = 'postmaster@analytics.msging.net';
const URL_REGEX = /^(https:\/\/)[a-z0-9]+[a-z0-9\-]*([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?/;
const MAX_URL_LENGTH = 512;
import { WEBHOOK_ACTIVE } from '../IntegrationsController';
import { WebhookFeatures } from './WebhookFeatures';
import { ReasonCodes } from 'types/ReasonCodes';
import { DISPATCH_TYPES_OPTIONS, AUTHORIZATION, WEBHOOK_ADVANCED_SETTINGS, WEBHOOK_OAUTH_ENABLED, WEBHOOK_URL } from './Constants';
import './WebhookView.scss';
import { IntegrationsFeatures } from '../IntegrationsFeatures';
export class WebhookController {
    static $inject = ['LoadingService', 'ConfigurationsService', '$translate', 'SegmentService', '$timeout', 'TranslateService', 'BlipToastService', 'MessagingHubService', '$scope'];
    constructor(LoadingService, ConfigurationsService, $translate, SegmentService, $timeout, TranslateService, BlipToastService, MessagingHubService, $scope) {
        'ngInject';
        this.LoadingService = LoadingService;
        this.ConfigurationsService = ConfigurationsService;
        this.$translate = $translate;
        this.SegmentService = SegmentService;
        this.$timeout = $timeout;
        this.TranslateService = TranslateService;
        this.BlipToastService = BlipToastService;
        this.MessagingHubService = MessagingHubService;
        this.$scope = $scope;
        //Feature Flags
        this.isShowingTicketsTypesWebhooks = false;
        this.isShowingOAuthOnWebhooks = false;
        this.isShowingDispatchTypesSettings = false;
        this.isShowingCustomHeadersOnWebhooks = false;
        this.areFailingWebhooksBeingBlocked = false;
        this.isConfigurationsApplicationsDomainUsageGetEnabled = false;
        this.isConfigurationsApplicationsDomainUsageSetEnabled = false;
        this.isShowingMonitoringsWebhooks = false;
        //URLs validation and blocking
        this.validatedUrls = [];
        this.isAnyUrlInvalid = false;
        this.switchDisabled = true;
        this.filteredDispatchTypesOptions = [];
        this.dispatchTypes = [];
        this.customHeaders = {};
        this.isTypeWebhookValid = [];
        this.isCustomHeadersValid = {};
        this.isAnyTypeWebhookInvalid = false;
        this.oauthEnabledUrls = [];
        this.isChipsClicked = false;
        this.advancedSettings = {};
        this.isOAuthClicked = false;
        this.onSelectChange = (event) => {
            const [, , , index] = event.target.id.split('-');
            const { detail: { data } } = event;
            this.dispatchTypes[index] = data;
            this.isTypeWebhookValid[index] = data.length !== 0;
            this.onTrackSendTypes(data);
            this.setExistTypeWebhookInvalidUrls();
        };
        this.onToggleAdvancedSettings = async (event) => {
            const [, , , index] = event.target.id.split('-');
            const { detail: { data } } = event;
            this.isTypeWebhookValid[index] = data.length !== 0;
        };
        this.onChipsClick = () => {
            this.isChipsClicked = true;
        };
        this.onMultipleSettingsChange = async (event) => {
            if (event.detail.data.length === 0) {
                this.onToggleAdvancedSettings(event);
            }
            else {
                this.onToggleAdvancedSettings(event);
                this.onSelectChange(event);
            }
        };
        this.onTrackSendTypes = async (data) => {
            this.$timeout(() => {
                if (!this.isChipsClicked) {
                    return;
                }
                this.SegmentService.createApplicationTrack({
                    trackEvent: 'integrations-webhook-settings-sending-types-select',
                    payload: {
                        selectedChips: data,
                    },
                });
                this.isChipsClicked = false;
            });
        };
        this.defaultDispatchTypes = () => {
            return this.filteredDispatchTypesOptions.map(option => this.dispatchOptions
                .filter(types => types.value === option)[0])
                .map(({ label }) => label);
        };
        this.getDispatchTypes = () => {
            const lists = this.getAdvancedSettingsArray('dispatchTypes');
            return lists;
        };
        this.getCustomHeaders = () => {
            const customHeaders = this.getAdvancedSettingsMap('customHeaders');
            return Object.entries(customHeaders).reduce((acc, [url, value]) => {
                acc[url] = this.convertObjectToKeyValueArray(value);
                return acc;
            }, {});
        };
        this.getConfigurationValuesArray = (name) => {
            return [...(this.settings[name] ?? '').split(';')].filter(val => val != '');
        };
        this.checkBlockedUrls = async () => {
            for (const currentUrl of this.urls) {
                const commandResponse = await this.MessagingHubService.processCommand({
                    method: 'get',
                    to: 'postmaster@analytics.msging.net',
                    uri: `/providers/blocked-status/${encodeURIComponent(currentUrl)}/Webhook`,
                });
                const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
                const blockerProviderItemTypes = { key: currentUrl, urlStatus: resource };
                this.urlsSituation.push(blockerProviderItemTypes);
            }
        };
        this.onToggleIntegration = async (event) => {
            const checked = event.detail.checked;
            if (checked != this.isActive) {
                this.isActive = checked;
                await this.updateWebhookActivationSettings();
                const successMsg = await this.$translate('utils.successMsg.8');
                this.BlipToastService.show('success', {
                    msg: successMsg,
                    duration: 4000,
                });
            }
        };
        this.onToggleOAuth = async (event) => {
            const url = event.target.dataset.url;
            const checked = event.detail.checked;
            if (url == '') {
                return;
            }
            if (!checked && this.isOAuthEnabled(url)) {
                this.oauthEnabledUrls = this.oauthEnabledUrls.filter((oauthUrl) => oauthUrl != url);
            }
            else if (checked && !this.isOAuthEnabled(url)) {
                this.oauthEnabledUrls.push(url);
            }
            const isValidHeaders = await this.customHeaderValidation(url);
            if (checked && !isValidHeaders) {
                return;
            }
            await this.saveOAuthUrls();
            const successMsg = await this.$translate('utils.successMsg.8');
            this.BlipToastService.show('success', {
                msg: successMsg,
                duration: 4000,
            });
            if (!this.isOAuthClicked) {
                return;
            }
            this.SegmentService.createApplicationTrack({
                trackEvent: 'integrations-webhook-settings-oauth-active',
                payload: {
                    toggle: Boolean(checked),
                },
            });
        };
        this.isAnyUrlEmpty = () => {
            return this.urls.some(url => url == '');
        };
        this.onChangeUrl = (event) => {
            const { detail: { value } } = event;
            const [, , id] = event.target.id.split('-');
            this.urls[id] = value;
            this.$timeout(() => {
                this.validatedUrls[id] = this.isUrlValid(value);
                this.setExistInvalidUrls();
            });
        };
        this.processAdvancedSettings = () => {
            if (this.urls.length == 0) {
                return [];
            }
            this.advancedSettings = {};
            this.urls.forEach((url, index) => {
                const userSelectedLabels = this.dispatchTypes[index] || [];
                this.advancedSettings[url] = { settings: {} };
                this.advancedSettings[url].settings = {
                    dispatchTypes: this.convertDispatchTypeLabelsToValues(userSelectedLabels),
                    customHeaders: this.convertKeyValueArrayToObject(this.customHeaders[url] || []),
                };
            });
            return Object.entries(this.advancedSettings).map(([k, v]) => ({ [k]: v }));
        };
        this.convertDispatchValuesToLabels = (values) => {
            if (!values)
                return [];
            return values.map(value => {
                const option = this.dispatchOptions.find(opt => opt.value === value);
                return option ? option.label : '';
            }).filter(label => label);
        };
        this.getDefaultDispatchTypeValues = () => {
            return this.dispatchOptions.map(option => option.value);
        };
        this.convertDispatchTypeLabelsToValues = (labels) => {
            if (!labels || labels.length === 0) {
                return this.getDefaultDispatchTypeValues();
            }
            return labels.map(label => {
                const option = this.dispatchOptions.find(opt => opt.label === label);
                return option ? option.value : null;
            }).filter(value => value);
        };
        this.convertKeyValueArrayToObject = (kvs) => {
            return kvs.reduce((acc, { key, value }) => {
                acc[key] = value;
                return acc;
            }, {});
        };
        this.convertObjectToKeyValueArray = (obj) => {
            return Object.entries(obj).map(([key, value]) => ({ key, value }));
        };
        this.customHeaderValidation = async (url = undefined) => {
            const validation = async (url) => {
                const customHeader = this.customHeaders[url] || [];
                const isOauthEnabled = this.oauthEnabledUrls.includes(url) || (!url && this.oauthEnabledUrls.length > 0);
                let valid = true;
                if (customHeader && customHeader.filter(h => h.key?.toLowerCase() == AUTHORIZATION.toLowerCase()).length > 0 && isOauthEnabled) {
                    const errorMsg = await this.$translate('webhook.page.customHeaders.errorMessageOAuth');
                    this.BlipToastService.show('danger', {
                        msg: errorMsg,
                    });
                    valid = false;
                }
                valid = valid && customHeader.every(({ key, value }) => !!key && !!value);
                return valid;
            };
            if (url) {
                this.isCustomHeadersValid[url] = await validation(url);
                return this.isCustomHeadersValid[url];
            }
            else {
                this.urls.forEach(async (url) => {
                    this.isCustomHeadersValid[url] = await validation(url);
                });
                return Object.values(this.isCustomHeadersValid).every((isValid) => isValid);
            }
        };
        this.removeUrl = async (index) => {
            const [url] = this.urls.splice(index, 1);
            this.validatedUrls.splice(index, 1);
            this.validateUrls();
            if (this.urls.length == 0) {
                await this.handleAllUrlsRemoved();
            }
            delete this.customHeaders[url];
            delete this.dispatchTypes[url];
        };
        this.hasBlockedTypes = (url) => {
            const currentProviderItemTypeSituation = this.urlsSituation.filter((urlSituation) => urlSituation.key == url)[0];
            return currentProviderItemTypeSituation ?
                currentProviderItemTypeSituation.urlStatus.items.filter((urlStatus) => urlStatus.isBlocked).length > 0 :
                false;
        };
        this.buildBlockedTypesMessage = (url) => {
            const currentProviderItemTypeSituation = this.urlsSituation.filter((urlSituation) => urlSituation.key == url)[0];
            let blockMessage = '';
            if (currentProviderItemTypeSituation) {
                const blockedItemsArray = [];
                for (const currentUrlStatus of currentProviderItemTypeSituation.urlStatus.items) {
                    if (currentUrlStatus.isBlocked) {
                        blockedItemsArray.push(this.TranslateService.instantTranslate(`webhook.page.blockedTypes.${currentUrlStatus.providerItemType.toString()}`));
                    }
                }
                const messageStart = this.TranslateService.instantTranslate('webhook.page.blockMessage.messageStart');
                const messageEnding = blockedItemsArray.length > 1 ?
                    this.TranslateService.instantTranslate('webhook.page.blockMessage.messageEndPlural') :
                    this.TranslateService.instantTranslate('webhook.page.blockMessage.messageEndSingular');
                blockMessage = `${messageStart} ${this.buildBlockedElementTypesText(blockedItemsArray)} ${messageEnding} `;
            }
            return blockMessage;
        };
        this.buildBlockedElementTypesText = (blockedItemsArray) => {
            return blockedItemsArray.reduce((previous, current, index, array) => {
                if (index === array.length - 1) {
                    return `${previous} ${this.TranslateService.instantTranslate('webhook.page.blockedItemSeparator')} ${current}`;
                }
                else {
                    return `${previous}, ${current}`;
                }
            });
        };
        this.handleAllUrlsRemoved = async () => {
            this.isActive = false;
            await this.save(false);
            const title = await this.$translate('modules.application.detail.integrations.webhook.toasts.urlsRemoved.title');
            const msg = await this.$translate('modules.application.detail.integrations.webhook.toasts.urlsRemoved.description');
            const buttonText = await this.$translate('utils.misc.helperConfirm');
            this.BlipToastService.show('warning', {
                title,
                msg,
                buttonText,
                duration: 7000,
            });
        };
        this.renderSuccessMsg = async () => {
            const successMsg = await this.$translate('utils.successMsg.8');
            this.BlipToastService.show('success', {
                msg: successMsg,
                duration: 4000,
            });
        };
        this.init();
    }
    async init() {
        await this.checkFeatures();
        this.settings = {};
        this.urls = [''];
        this.urlsSituation = [];
        this.isActive = false;
        this.filteredDispatchTypesOptions = DISPATCH_TYPES_OPTIONS;
        if (!this.isShowingTicketsTypesWebhooks) {
            this.filteredDispatchTypesOptions = DISPATCH_TYPES_OPTIONS.filter(option => option !== 'tickets');
        }
        if (!this.isShowingMonitoringsWebhooks) {
            this.filteredDispatchTypesOptions = DISPATCH_TYPES_OPTIONS.filter(option => option !== 'monitorings');
        }
        this.dispatchOptions = this.filteredDispatchTypesOptions.map((option) => ({
            label: this.TranslateService.instantTranslate(`webhook.page.configurations.settings.dispatchTypes.${option}`),
            value: option,
        }));
        await this.fetchConfiguration();
    }
    getAdvancedSettingsArray(configName) {
        const urlValueTuple = this.getAdvancedSettings(configName);
        return urlValueTuple.map(([_, value]) => (value));
    }
    getAdvancedSettingsMap(configName) {
        const urlValueTuple = this.getAdvancedSettings(configName);
        return Object.fromEntries(urlValueTuple);
    }
    getAdvancedSettings(configName) {
        const urls = Object.keys(this.advancedSettings);
        return urls.map(url => [url, this.advancedSettings[url].settings[configName]]);
    }
    async fetchConfiguration() {
        try {
            this.LoadingService.startLoading();
            this.settings = await this.ConfigurationsService.get(ANALYTICS_OWNER_IDENTITY, undefined, this.isConfigurationsApplicationsDomainUsageGetEnabled);
            this.urls = this.getConfigurationValuesArray(WEBHOOK_URL);
            if (this.isShowingDispatchTypesSettings) {
                this.advancedSettings = Object.assign({}, ...JSON.parse(this.settings[WEBHOOK_ADVANCED_SETTINGS] || '[]'));
                const savedValues = this.getDispatchTypes();
                this.dispatchTypes = savedValues.map(valueList => this.convertDispatchValuesToLabels(valueList));
                this.customHeaders = this.getCustomHeaders() || {};
            }
            this.oauthEnabledUrls = this.getConfigurationValuesArray(WEBHOOK_OAUTH_ENABLED);
            this.isActive =
                this.settings[WEBHOOK_ACTIVE].toLowerCase() == 'true'
                    ? true
                    : false;
            if (this.areFailingWebhooksBeingBlocked && !this.isAnyUrlEmpty()) {
                await this.checkBlockedUrls();
            }
        }
        catch (ex) {
            console.warn(ex);
            if (!ex.code || ex.code != ReasonCodes.ResourceNotFound) {
                const errorMsg = await this.$translate('webhook.messages.errorLoading');
                this.BlipToastService.show('danger', {
                    msg: errorMsg,
                    duration: 4000,
                });
            }
        }
        finally {
            this.validateUrls();
            this.handleSwitchBehavior();
            this.LoadingService.stopLoading();
        }
    }
    async checkFeatures() {
        this.isShowingTicketsTypesWebhooks = await WebhookFeatures.isShowingTicketsTypesWebhooks();
        this.isShowingOAuthOnWebhooks = await WebhookFeatures.isShowingOAuthOnWebhooks();
        this.areFailingWebhooksBeingBlocked = await WebhookFeatures.areFailingWebhooksBeingBlocked();
        this.isShowingDispatchTypesSettings = await WebhookFeatures.isShowingDispatchTypesSettings();
        this.isShowingCustomHeadersOnWebhooks = await WebhookFeatures.isShowingCustomHeadersOnWebhooks();
        this.isShowingMonitoringsWebhooks = await WebhookFeatures.isShowingMonitoringsWebhooks();
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await IntegrationsFeatures.isConfigurationsDomainOnChannelsOperationsGetEnabled();
        this.isConfigurationsApplicationsDomainUsageSetEnabled = await IntegrationsFeatures.isConfigurationsDomainOnChannelsOperationsSetEnabled();
    }
    isOAuthEnabled(url) {
        const includes = this.oauthEnabledUrls.includes(url);
        return includes;
    }
    integrationsSettingsOAuth() {
        this.isOAuthClicked = true;
    }
    isUrlValid(url) {
        const regex = new RegExp(URL_REGEX);
        const isUrlLengthValid = url.length <= MAX_URL_LENGTH;
        const isUrlRegexValid = url.match(regex) ? true : false;
        const isUnique = this.urls.filter((currentUrl) => currentUrl == url).length == 1;
        return isUrlLengthValid && isUrlRegexValid && isUnique;
    }
    validateUrls() {
        if (this.validatedUrls.length) {
            this.urls.forEach((url, index) => {
                this.validatedUrls[index] = this.isUrlValid(url);
            });
        }
        else {
            this.urls.forEach(url => this.validatedUrls.push(url == '' || this.isUrlValid(url)));
        }
        this.setExistInvalidUrls();
    }
    setExistInvalidUrls() {
        this.$timeout(() => {
            this.isAnyUrlInvalid = this.validatedUrls.filter(status => status === false).length > 0 || this.isAnyUrlEmpty();
        });
    }
    setExistTypeWebhookInvalidUrls() {
        this.$timeout(() => {
            this.isAnyTypeWebhookInvalid = this.isTypeWebhookValid.filter(status => status === false).length > 0;
        });
    }
    setExistInvalidHeaders() {
        this.$timeout(() => {
            this.isAnyTypeWebhookInvalid = this.isTypeWebhookValid.filter(status => status === false).length > 0;
        });
    }
    shouldDisableSave() {
        return this.isAnyUrlInvalid
            || (this.isShowingDispatchTypesSettings && this.isAnyTypeWebhookInvalid)
            || (this.isShowingCustomHeadersOnWebhooks && Object.values(this.isCustomHeadersValid).some((isValid) => !isValid));
    }
    handleSwitchBehavior() {
        const urlsAreEmpty = this.urls.length == 0 || this.urls[0] == '';
        this.switchDisabled = this.isAnyUrlInvalid || urlsAreEmpty;
    }
    async save(showSuccessMsg = true) {
        try {
            this.LoadingService.startLoading();
            if (await this.saveWebhooksUrls()
                && await this.saveOAuthUrls()
                && await this.saveAdvancedSettings()
                && await this.updateWebhookActivationSettings()) {
                this.handleSwitchBehavior();
                showSuccessMsg && this.renderSuccessMsg();
            }
            else {
                const errorMsg = await this.$translate('utils.errorMsg.10');
                this.BlipToastService.show('danger', {
                    msg: errorMsg,
                });
            }
            this.$scope.$broadcast('save');
        }
        catch (err) {
            console.error(err);
            const errorMsg = await this.$translate('utils.errorMsg.10');
            this.BlipToastService.show('danger', {
                msg: errorMsg,
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async saveWebhooksUrls() {
        let success = true;
        try {
            const validUrls = this.urls.filter(url => url);
            this.settings[WEBHOOK_URL] = validUrls.join(';');
            await this.ConfigurationsService.set(ANALYTICS_OWNER_IDENTITY, this.settings, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
        }
        catch (error) {
            success = false;
            console.error('Error while saving webhook urls configuration');
        }
        return success;
    }
    async saveOAuthUrls() {
        let success = true;
        try {
            const validUrls = this.oauthEnabledUrls.filter(url => url);
            this.settings[WEBHOOK_OAUTH_ENABLED] = validUrls.join(';');
            await this.ConfigurationsService.set(ANALYTICS_OWNER_IDENTITY, this.settings, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
        }
        catch (error) {
            success = false;
            console.error('Error while saving webhook oauth configuration');
        }
        return success;
    }
    async saveAdvancedSettings() {
        let success = true;
        try {
            const isValidHeaders = await this.customHeaderValidation();
            if (!isValidHeaders) {
                return isValidHeaders;
            }
            const newAdvancedSettings = this.processAdvancedSettings();
            this.settings[WEBHOOK_ADVANCED_SETTINGS] = JSON.stringify(newAdvancedSettings);
            await this.ConfigurationsService.set(ANALYTICS_OWNER_IDENTITY, this.settings, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
        }
        catch (error) {
            success = false;
            console.error('Error while saving webhook advanced settings');
            console.error(error);
        }
        return success;
    }
    async updateWebhookActivationSettings() {
        let success = true;
        try {
            this.settings[WEBHOOK_ACTIVE] = this.isActive;
            await this.ConfigurationsService.set(ANALYTICS_OWNER_IDENTITY, this.settings, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
            if (this.isActive) {
                this.SegmentService.createApplicationTrack({
                    trackEvent: 'integrate-chatbot',
                    payload: {
                        integration: 'Webhook',
                    },
                });
            }
        }
        catch (e) {
            success = false;
            console.error('Error while saving webhook activation');
        }
        return success;
    }
    integrationsWebhookOverview() {
        this.SegmentService.createApplicationTrack({
            trackEvent: 'integrations-webhook-overview',
        });
    }
    integrationsWebhookSettings() {
        this.SegmentService.createApplicationTrack({
            trackEvent: 'integrations-webhook-settings',
        });
    }
    integrationSettingsAdvanced(e) {
        if (e.isActive) {
            this.SegmentService.createApplicationTrack({
                trackEvent: 'integrations-webhook-settings-advanced-settings-open',
            });
        }
    }
    addUrl() {
        if (this.urls.length >= 10) {
            return;
        }
        this.urls = this.urls.concat(['']);
        this.validatedUrls.push(true);
        this.setExistInvalidUrls();
    }
}
WebhookController.$inject = ['LoadingService', 'ConfigurationsService', '$translate', 'SegmentService', '$timeout', 'TranslateService', 'BlipToastService', 'MessagingHubService', '$scope'];
